enum FootSideEnum {
    Left = 'left',
    Right = 'right',
}

export default FootSideEnum;
